const faqData = [
  {
    q: '香蕉影视真的完全免费吗？',
    a: '是的，香蕉影视始终坚持免费策略，所有电影、电视剧、综艺、动漫等内容均可免费在线观看，不收取任何费用。我们通过广告合作维持平台运营，确保用户享受无门槛的高清观影体验。',
  },
  {
    q: '为什么我的播放偶尔会出现卡顿？',
    a: '播放卡顿通常与当前网络环境有关。香蕉影视采用智能CDN加速和自适应码率技术，会自动根据您的网速调整画质。建议检查Wi-Fi信号强度或切换至4G/5G网络，同时关闭后台占用带宽的应用以获得最佳体验。',
  },
  {
    q: '是否需要下载APP才能观看？',
    a: '不需要！香蕉影视为纯网页端平台，使用手机或电脑浏览器打开即可直接观看，无需下载安装任何应用。我们已完美适配iOS和Android移动端浏览器，支持全屏播放、投屏等功能。',
  },
  {
    q: '影片更新速度怎么样？新上映的电影多久能看到？',
    a: '我们的内容团队每日持续更新，平均每天上线30+部新内容。热门综艺通常在播出后24小时内更新，院线新片在首映后会尽快上线。您可以通过"最新动态"模块实时关注上新信息。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="relative w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50 mb-3">常见问题</h2>
          <p className="text-foreground-400 text-sm">关于香蕉影视，你可能想了解的信息</p>
        </div>
        <div className="max-w-[800px] mx-auto space-y-3">
          {faqData.map((item, i) => (
            <div key={i} className="rounded-xl bg-background-200/60 border border-background-300/40 overflow-hidden">
              <div className="p-5 md:p-6">
                <h3 className="font-bold text-foreground-50 text-sm md:text-base mb-2 flex items-start gap-2">
                  <span className="text-primary-400 flex-shrink-0 mt-0.5">Q</span>
                  <span>{item.q}</span>
                </h3>
                <p className="text-sm text-foreground-400 leading-relaxed pl-6">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}